import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'payments'
})
export class PaymentsPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
